
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import labelSelect from "./components/label-select.vue"
import area from '@/utils/area'
import AreaSelect from '@/components/area-select.vue'
import {apiPointList,
  apiSetTag,
  apiSetPlatformPutStatus,
  apiSetStatus,
  apiSetSupplier,
  apiAudit,
  apiSupplierList,
  apiDelSupplier
} from '@/api/operating/group_welfare/point'
import { RequestPaging } from '@/utils/util'
import { apiTagList } from '@/api/operating/group_welfare/tag'

@Component({
  components: {
    lsPagination,
    labelSelect,
    AreaSelect
  }
})
export default class Points extends Vue  {
  $refs!:{ suTable:any }
  /** S Data*/
  pager: RequestPaging = new RequestPaging();
  supplierPager: RequestPaging = new RequestPaging();
  active:any = 'all'
  query:any = {}
  labelList = []
  selectIds = []
  
  supplierForm:any = {}
  supplierDialog = false
  supplierQuery:any = {}
  
  setLabelDialog = false
  labelForm:any = {
    shop_id: '',
    label_ids: []
  }
  
  pointStatus:any = {
    'all': '',
    'wait': 0,
    'open': 1,
    'fail': 2,
    'close': 3,
  }
  
  openDialog = false
  openData = {}
  auditForm:any = {
    platform_put: 0
  }
  rejectedDialog = false
  /** E Data*/
  
  /** S Methods*/
  // 获取点位列表
  getPointList(page?:number) {
    page && (this.pager.page = page)
    this.query.point_status = this.pointStatus[this.active]
    this.pager.request({
      callback: apiPointList,
      params: {
        ...this.query
      }
    })
  }
  // 列表选中
  selectionTable(val: any) {
    this.selectIds = val.map((item:any) => item.id)
  }
  // 点位审核
  audit(row: any, status:any) {
    this.auditForm = {
      shop_id: row.id,
      status: status,
      audit_reason: '',
      label_ids: []
    }
    this.openData = row
    if (status == 2) {
      this.rejectedDialog = true
    } else {
      this.openDialog = true
    }
  }
  // 执行审核
  doAudit() {
    if (this.auditForm.status == 2 && !this.auditForm.audit_reason) {
      this.$message.error('请输入驳回理由')
      return
    } else if (this.auditForm.status == 1 && this.auditForm.label_ids.length <= 0) {
      this.$message.error('请选择标签')
      return
    }
    apiAudit(this.auditForm).then(res => {
      this.rejectedDialog = this.openDialog = false
      this.getPointList(1)
    })
  }
  // 设置供应商
  setSupplier(row: any, type:string) {
    this.supplierForm.shop_id = row.id
    this.supplierQuery = {
      shop_id: row.id,
      exist: type
    }
    this.supplierDialog = true
    this.getSupplierList(1);
  }
  // 获取供应商列表
  getSupplierList(page?:number) {
    page && (this.supplierPager.page = page)
    this.supplierPager.request({
      callback: apiSupplierList,
      params: {
        ...this.supplierQuery
      }
    }).then(res => {
      let shop = this.pager.lists.find((i:any) => i.id == this.supplierForm.shop_id)
      res.lists.forEach((item:any) => {
         if (shop.supplier_ids.indexOf(item.id+'') >= 0) {
           this.$refs.suTable.toggleRowSelection(item)
         }
      })
    })
  }
  // 供应商列表重置
  supplierReset() {
    let shop_id = this.supplierQuery.shop_id
    let exist = this.supplierQuery.exist
    this.supplierQuery = {shop_id, exist}
    this.getSupplierList(1)
  }
  selectionSupplier(val:any) {
    this.supplierForm.supplier_id = val.map((item:any) => item.id)
  }
  // 执行分配供应商
  doSetSupplier() {
    this.$confirm(`确认分配供应商吗？`,'提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      apiSetSupplier(this.supplierForm).then(res => {
        this.supplierDialog = false
        this.getPointList(1)
      })
    }).catch(() => {})
  }
  // 移除供应商
  delSupplier(id:any) {
    this.$confirm(`确认将此供应商从点位移除？移除后，该供应商将不能自主投放群福利活动到该点位，已产生的订单不受影响。`,'提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      apiDelSupplier({supplier_id: id, shop_id: this.supplierQuery.shop_id}).then(res => {
        this.getPointList(1)
        this.supplierDialog = false
      })
    }).catch(() => {})
  }
  // 批量设置标签
  batchSetLabel() {
    this.labelForm.shop_id = this.selectIds
    this.setLabelDialog = true
  }
  // 设置标签
  setLabel(row: any) {
    this.labelForm.shop_id = row.id
    this.labelForm.label_ids = row.tag_ids
    this.setLabelDialog = true
  }
  // 设置标签提交
  doSetLabel() {
    if (this.labelForm.label_ids.length <= 0) {
      this.$message.error('请选择标签');
      return
    }
    apiSetTag(this.labelForm).then(res => {
      this.getPointList(1)
      this.setLabelDialog = false
    })
  }
 
  batchSetPlatformPut(status:number) {
    this.setPlatformPut(status)
  }
  setPlatformPut(status:any, id:any = '') {
    let ids = id ? [id] : this.selectIds;
    apiSetPlatformPutStatus({shop_id: ids, status: status}).then(res => {
      this.getPointList(1);
    })
  }
  
  changeStatus(row: any, status: number) {
    this.$confirm(`确认${status == 1 ? '开启': '关闭'}点位吗？`,'提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      apiSetStatus({shop_id: row.id, status: status}).then(res => {
        this.getPointList(1)
      })
    }).catch(() => {})
  }
  
  /** E Methods*/
  created() {
    apiTagList({page_no: 1, page_size: 10000}).then(res => {
      this.labelList = res.lists
    })
    this.getPointList()
  }
}
